export const FOOTER_LINKS = {
  CONTACT: 'mailto:PSOnDemand@pagerduty.com',
  TERMS: 'https://www.pagerduty.com/terms-of-service/',
  PRIVACY: 'https://www.pagerduty.com/privacy-policy/',
  DEVELOPER_DOCS: 'https://developer.pagerduty.com/',
  SYSTEM_STATUS: 'https://status.pagerduty.com/posts/dashboard',
} as const;

export const RESOURCES_LINKS = [
  {
    title: 'Teams and Users',
    items: [
      {
        title: 'Teams Documentation',
        link: 'https://support.pagerduty.com/main/docs/teams',
      },
      {
        title: 'Manage Users',
        link: 'https://support.pagerduty.com/main/docs/manage-users',
      },
      {
        title: 'User Profile',
        link: 'https://support.pagerduty.com/main/docs/user-profile',
      },
      {
        title: 'User Roles',
        link: 'https://support.pagerduty.com/main/docs/user-roles',
      },
      {
        title: 'Advanced Permissions',
        link: 'https://support.pagerduty.com/main/docs/advanced-permissions',
      },
    ],
  },
  {
    title: 'On-Call Schedules',
    items: [
      {
        title: 'Schedule Basics',
        link: 'https://support.pagerduty.com/main/docs/schedule-basics',
      },
      {
        title: 'Schedule Examples',
        link: 'https://support.pagerduty.com/main/docs/schedule-examples',
      },
      {
        title: 'My On-Call Shifts',
        link: 'https://support.pagerduty.com/main/docs/my-on-call-shifts',
      },
    ],
  },
  {
    title: 'Escalation Policies',
    items: [
      {
        title: 'Escalation Policy Basics',
        link: 'https://support.pagerduty.com/main/docs/escalation-policies',
      },
      {
        title: 'Round Robin Scheduling',
        link: 'https://support.pagerduty.com/main/docs/round-robin-scheduling',
      },
      {
        title: 'Escalation Policies & Schedules',
        link: 'https://support.pagerduty.com/main/docs/escalation-policies-and-schedules',
      },
    ],
  },
  {
    title: 'Services Graph',
    items: [
      {
        title: 'Services and Integrations',
        link: 'https://support.pagerduty.com/main/docs/services-and-integrations',
      },
      {
        title: 'Configurable Service Settings',
        link: 'https://support.pagerduty.com/main/docs/configurable-service-settings',
      },
      {
        title: 'Custom Fields on Services',
        link: 'https://support.pagerduty.com/main/docs/custom-fields-on-services',
      },
      {
        title: 'Service Ownership Ops',
        link: 'https://ownership.pagerduty.com/',
      },
      {
        title: 'Service Graph Standards',
        link: 'https://www.youtube.com/watch?v=9Iy_86C4wG4',
      },
      {
        title: 'Services & Integrations',
        link: 'https://www.youtube.com/watch?v=fdXoAJGePVI',
      },
    ],
  },
  {
    title: 'Incident Management',
    items: [
      {
        title: 'Incident Workflows',
        link: 'https://support.pagerduty.com/main/docs/incident-workflows',
      },
      {
        title: 'Incident Types',
        link: 'https://support.pagerduty.com/main/docs/incident-types',
      },
      {
        title: 'Incident Roles',
        link: 'https://support.pagerduty.com/main/docs/incident-roles',
      },
      {
        title: 'Custom Fields on Incidents',
        link: 'https://support.pagerduty.com/main/docs/custom-fields-on-incidents',
      },
    ],
  },
] as const;
